/*
*###############################################################################
*Module Name                   : DesignationMaster.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Monday, August 30th 2021, 10:14:01 am         #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React from 'react'
import { Col, Row, Alert } from 'reactstrap'
import DPTextBox from 'framework/components/DPTextBox'

const MonthEndContent = ({
    Month,
    Year,
    YearOnChange,
    MonthOnChange,
    MonthOnBlur,
    YearOnBlur,
    show,
    AlertColor,
    AlertMsg,
    currentRunningMonth,
    currentRunningYear
}) => {

    const lastMonthEndMonth = currentRunningMonth == 1 ? 12 : currentRunningMonth - 1
    const lastMonthEndYear = currentRunningMonth == 1 ? currentRunningYear - 1 : currentRunningYear



    return (
        <React.Fragment>

            <Row>          {show ? (
                <Alert color={AlertColor} role="alert">
                    {AlertMsg}
                    <br />
                </Alert>
            ) : null}
            </Row>
            <Row>
                <label className="col-sm-6 col-md-3 col-form-label">
                    Current (Month): <span style={{ fontWeight: 'bold' }}>{new Date().getMonth() + 1}</span>
                </label>
                <label className="col-sm-6 col-md-3 col-form-label">
                    Current (Year):  <span style={{ fontWeight: 'bold' }}>{new Date().getFullYear()}</span>
                </label>
            </Row>
            <Row>
                <label className="col-sm-6 col-md-3 col-form-label">
                    Current system Running (Month): <span style={{ fontWeight: 'bold' }}>{currentRunningMonth}</span>
                </label>
                <label className="col-sm-6 col-md-3 col-form-label">
                    Current system Running (Year):  <span style={{ fontWeight: 'bold' }}>{currentRunningYear}</span>
                </label>
            </Row>
            <Row>
                <label className="col-sm-6 col-md-3 col-form-label">
                    Last Month-End Peformed (Month): <span style={{ fontWeight: 'bold' }}>{lastMonthEndMonth}</span>
                </label>
                <label className="col-sm-6 col-md-3 col-form-label">
                    Last Month-End Peformed (Year):  <span style={{ fontWeight: 'bold' }}>{lastMonthEndYear}</span>
                </label>
            </Row>
            <Row className='mt-3'>
                <Col sm={12} md={6} className="mb-4-sm">
                    <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="Month"
                        textType="text"
                        maxLength="2"
                        value={Month}
                        onChange={MonthOnChange}
                        onBlur={MonthOnBlur}
                    />

                    <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="Year"
                        textType="text"
                        maxLength="4"
                        value={Year}
                        onChange={YearOnChange}
                        onBlur={YearOnBlur}
                    />
                </Col>
            </Row>



        </React.Fragment>
    )

}

export default MonthEndContent